import { render, staticRenderFns } from "./Settori.vue?vue&type=template&id=376ab624"
import script from "./Settori.vue?vue&type=script&lang=js"
export * from "./Settori.vue?vue&type=script&lang=js"
import style0 from "./Settori.vue?vue&type=style&index=0&id=376ab624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports